// extracted by mini-css-extract-plugin
export default {"wysiwyg":"wysiwyg-module--wysiwyg--a56fe","fadeIn":"wysiwyg-module--fadeIn--a86a1"};